import script from "./PlantEquipmentRegisterView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantEquipmentRegisterView.vue?vue&type=script&setup=true&lang=js"

import "./PlantEquipmentRegisterView.vue?vue&type=style&index=0&id=5cfc0881&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfc0881"]])

export default __exports__